import { useTranslations } from "context/TranslationContext";
import Image from "next/image";
import Link from "next/link";
import NextHead from "next/head";
import React from "react";
import { getLocalizedString } from "utils/helpers";
import professions_community from "../assets/Professions_Community.png";

const Maintenance = () => {
  const { translations } = useTranslations();
  return (
    <div className="text-white flex flex-col justify-center text-center items-center my-10 px-6">
      <NextHead>
        <meta name="robots" content="none" />
      </NextHead>
      <h1 className="text-2xl font-bold">
        {getLocalizedString(translations, "maintenance-page-title")}
      </h1>
      <p className="text-lg">
        {getLocalizedString(translations, "maintenance-page-description")}
      </p>
      <div className="mt-5">
        <Image
          width={300}
          height={300}
          src={professions_community.src}
          alt="maintenance"
        />
      </div>
      <div className="mb-5">
        <Link href="/">
          <a className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-black bg-white sm:hover:bg-opacity-50">
            {getLocalizedString(translations, "404-button")}
          </a>
        </Link>
      </div>
    </div>
  );
};

export default Maintenance;
